var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-bar" }, [
    _c("div", { class: { center: _vm.type == "center" } }, [
      _c("div", { staticClass: "nav-left" }, [
        _c("a", { attrs: { href: _vm.baseUrl, target: "_blank" } }, [
          _c("img", { attrs: { src: require("assets/logo.png") } })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav-right" },
        [
          _c(
            "el-dropdown",
            { attrs: { placement: "bottom-start", "hide-on-click": false } },
            [
              _c("div", { staticClass: "workorder" }, [
                _c("svg", { staticClass: "icon" }, [
                  _c("use", { attrs: { "xlink:href": "#icon-gongdan" } })
                ]),
                _vm._v("\n          工单\n          "),
                _c("i", { staticClass: "el-icon-arrow-down" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "dropdown-menu-wrapper",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown"
                },
                [
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/workorder/myworkorder" } },
                        [
                          _c("svg", { staticClass: "icon" }, [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-workorder" }
                            })
                          ]),
                          _vm._v("\n              我的工单\n            ")
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/workorder/commit" } },
                        [
                          _c("svg", { staticClass: "icon" }, [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tijiao" }
                            })
                          ]),
                          _vm._v("\n              提交工单\n            ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dropdown",
            { attrs: { "hide-on-click": false } },
            [
              _c("div", { staticClass: "finance" }, [
                _c("svg", { staticClass: "icon" }, [
                  _c("use", { attrs: { "xlink:href": "#icon-caiwu" } })
                ]),
                _vm._v("\n          财务\n          "),
                _c("i", { staticClass: "el-icon-arrow-down" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "dropdown-menu-wrapper balance-menu",
                  staticStyle: { "min-width": "2.2rem" },
                  attrs: { slot: "dropdown" },
                  slot: "dropdown"
                },
                [
                  _c("el-dropdown-item", [
                    _c("div", { staticClass: "balance" }, [
                      _c(
                        "p",
                        [
                          _c("span", [
                            _c("svg", { staticClass: "icon" }, [
                              _c("use", {
                                attrs: { "xlink:href": "#icon-dollor" }
                              })
                            ]),
                            _vm._v("\n                  余额\n                ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            { attrs: { to: "/center/charge" } },
                            [
                              _c("el-button", { attrs: { size: "mini" } }, [
                                _vm._v("立即充值")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "balance-val" }, [
                        _vm._v(
                          "¥" + _vm._s(_vm.$store.state.balance.formatBalance)
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    { attrs: { divided: "" } },
                    [
                      _c("router-link", { attrs: { to: "/center/account" } }, [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", { attrs: { "xlink:href": "#icon-caiwu" } })
                        ]),
                        _vm._v("\n              账户\n            ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    [
                      _c("router-link", { attrs: { to: "/center/order" } }, [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", { attrs: { "xlink:href": "#icon-order" } })
                        ]),
                        _vm._v("\n              订单管理\n            ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    [
                      _c("router-link", { attrs: { to: "/center/invoice" } }, [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-fapiaoguanli" }
                          })
                        ]),
                        _vm._v("\n              发票管理\n            ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dropdown",
            { attrs: { placement: "bottom", "hide-on-click": false } },
            [
              _c("div", { staticClass: "username" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$store.state.auth.nickname ||
                        _vm.$store.state.auth.email
                    )
                  )
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-arrow-down" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "dropdown-menu-wrapper",
                  staticStyle: { "min-width": "2rem" },
                  attrs: { slot: "dropdown" },
                  slot: "dropdown"
                },
                [
                  _c("el-dropdown-item", [
                    _c(
                      "div",
                      {
                        staticClass: "email",
                        attrs: { title: _vm.$store.state.auth.email }
                      },
                      [
                        _c("p", [_vm._v(_vm._s(_vm.$store.state.auth.email))]),
                        _vm._v(" "),
                        _c("div", { staticClass: "certi-area" }, [
                          _c(
                            "div",
                            {
                              class: "certi-every certi-" + _vm.typeClass,
                              on: {
                                click: function($event) {
                                  _vm.goLink("/user/authentication")
                                }
                              }
                            },
                            [
                              _c("div", {
                                class: "icon-cert " + _vm.typeClass + "-icon"
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$store.state.auth.certificateDesc)
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    [
                      _c("router-link", { attrs: { to: "/app/myapp" } }, [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-appmanage" }
                          })
                        ]),
                        _vm._v("\n              我的应用\n            ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    [
                      _c("router-link", { attrs: { to: "/user/baseinfo" } }, [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", { attrs: { "xlink:href": "#icon-user" } })
                        ]),
                        _vm._v("\n              基本资料\n            ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    [
                      _c("router-link", { attrs: { to: "/user/security" } }, [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", { attrs: { "xlink:href": "#icon-anquan" } })
                        ]),
                        _vm._v("\n              安全设置\n            ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-dropdown-item", { attrs: { divided: "" } }, [
                    _c(
                      "div",
                      { staticClass: "logout" },
                      [
                        _c("router-link", { attrs: { to: "/logout" } }, [
                          _c("svg", { staticClass: "icon" }, [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-logout" }
                            })
                          ]),
                          _vm._v("\n                退出登录\n              ")
                        ])
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ae1d43b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ae1d43b","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/NavBar/Main.vue
// module id = 762
// module chunks = 40